import type ArrayProxy from '@ember/array/proxy';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type AverageMonthlyVisitorCount from 'garaje/models/average-monthly-visitor-count';
import type Group from 'garaje/models/group';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import type { PromiseArray } from 'garaje/utils/type-utils';
import { hash } from 'rsvp';

export interface LocationOverviewLocationsRouteModelWithGroups {
  groups?: ArrayProxy<Group> | Group[];
  averageMonthlyVisitorCount: ArrayProxy<AverageMonthlyVisitorCount>;
}

export default class LocationOverviewLocationsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  beforeModel(): void {
    if (!this.globalOverviewAccess.canVisitGlobalLocation) {
      this.router.transitionTo('unauthorized');
    }
  }

  model(): Promise<LocationOverviewLocationsRouteModelWithGroups> {
    let groups: Group[] | PromiseArray<Group, ArrayProxy<Group>> = [];

    if (this.abilities.can('manage locations-grouping')) {
      groups = this.store.findAll('group');
    }

    return hash({
      groups,
      averageMonthlyVisitorCount: this.store.findAll('average-monthly-visitor-count'),
    });
  }
}
